import { Activity } from '../../../features/activity-selector/models';

// Check if there's default product box defined
// orderedProductBoxNumbers (multiple product boxes) is introduced in FS Performance > v4.6
// defaultProductBoxNumbers is used in FS Performance < v4.6
export function hasDefaultProductBox(activity: Activity | undefined) {
    return (
        (!!activity?.orderedProductBoxNumbers && activity?.orderedProductBoxNumbers.length > 0) ||
        !!activity?.defaultProductBoxNumber
    );
}
